import React, { useState } from 'react';
import PropTypes from 'prop-types';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Collapse, IconButton, Paper } from '@mui/material';

import { useTheme } from 'contexts/ThemeContext';

import { HelpTooltip, Text } from 'components/DataDisplay';

export const DomainPageSection = props => {
  const { children, title, error, justify, tooltip } = props;
  const { themeColors } = useTheme();
  const [open, setOpen] = useState(true);

  const toggleOpen = () => {
    setOpen(prev => !prev);
  };

  return (
    <Paper
      elevation={1}
      sx={{
        padding: '1rem',
        '& .MuiGrid-container': {
          width: '100% !important',
          margin: '0 !important',
          minWidth: 0
        },
        '& .MuiGrid-root': {
          maxWidth: '100%',
          minWidth: 0,
          boxSizing: 'border-box'
        },
        '& .MuiFormControl-root': {
          maxWidth: '100%',
          minWidth: 0
        },
        '& .MuiInputBase-root': {
          maxWidth: '100%',
          minWidth: 0
        },
        '& .MuiSelect-select, & .MuiInputBase-input': {
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        },
        '& .MuiTypography-root, & p': {
          maxWidth: '100%',
          overflowWrap: 'anywhere',
          whiteSpace: 'normal'
        },
        '& img': {
          maxWidth: '100%'
        }
      }}
      style={{
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        borderRadius: '8px',
        marginBottom: '0.75rem',
        overflowX: 'hidden'
      }}
    >
      <Box style={{ width: '100%' }}>
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            width: '100%'
          }}
        >
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              flex: '0 1 auto',
              minWidth: 0
            }}
          >
            <Text
              color={error && themeColors.error}
              variant="h6"
              bold
              style={{
                fontSize: '0.9rem',
                lineHeight: 1.3,
                overflowWrap: 'anywhere'
              }}
            >
              {title}
            </Text>
            {tooltip && (
              <HelpTooltip
                title={tooltip}
                style={{
                  paddingLeft: '10px'
                }}
              />
            )}
          </Box>
          <Box
            style={{
              flex: '1 1 auto',
              height: '2px',
              backgroundColor: themeColors.light,
              opacity: 0.7
            }}
          />
          <Box style={{ flex: '0 0 auto' }}>
            <IconButton
              aria-label={open ? 'Fermer la carte' : 'Ouvrir la carte'}
              size="small"
              onClick={toggleOpen}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </Box>
        </Box>
        <Collapse in={open}>
          <Box
            sx={{
              width: '100%',
              pt: '0.85rem',
              '& > .MuiGrid-root': {
                width: '100%',
                maxWidth: '100%',
                justifyContent: justify
              },
              '& .MuiGrid-grid-xs-12:not(:last-child)': {
                marginBottom: '0.75rem !important'
              },
              '& .MuiGrid-root': {
                minWidth: 0,
                maxWidth: '100%'
              },
              '& .MuiFormControl-root': {
                maxWidth: '100%'
              }
            }}
          >
            {children}
          </Box>
        </Collapse>
      </Box>
    </Paper>
  );
};

DomainPageSection.defaultProps = {
  error: false,
  justify: 'flex-start',
  tooltip: false
};

DomainPageSection.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  error: PropTypes.bool,
  justify: PropTypes.string,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default DomainPageSection;
